var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-card"},[_c('b-card',[_vm._t("img-element"),_c('b-card-text',[_vm._t("text-element")],2)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }